import { styled } from '@mui/material';

export const Separator = styled('div')(({ theme }) => ({
  height: '4px',
  width: '4px',
  borderRadius: '100%',
  backgroundColor: theme.palette.grey[500],
}));
